import { useState, useEffect } from 'react';

/**
 * 数字递增动画Hook
 * @param isVisible 是否可见（触发动画）
 * @param endValue 结束值
 * @param duration 动画持续时间（毫秒）
 * @param startValue 起始值
 * @returns 当前数值
 */
export const useCountUp = (
  isVisible: boolean,
  endValue: number,
  duration: number = 2000,
  startValue: number = 0
): string => {
  const [currentValue, setCurrentValue] = useState(startValue);

  useEffect(() => {
    if (!isVisible) return;

    let startTime: number;
    let animationFrame: number;

    const animate = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      
      // 使用缓动函数（ease-out）
      const easeOut = 1 - Math.pow(1 - progress, 3);
      const value = Math.floor(startValue + (endValue - startValue) * easeOut);
      
      setCurrentValue(value);

      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate);
      }
    };

    animationFrame = requestAnimationFrame(animate);

    return () => {
      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
      }
    };
  }, [isVisible, endValue, duration, startValue]);

  return currentValue.toString();
};

export default useCountUp;